import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Alert,
  AlertIcon,
  Button,
  List,
  ListItem,
  ListIcon,
  Text,
  VStack,
} from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';

interface ProceedToApplicationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  /** True when proceeding creates an application for every quote in a group. */
  isGrouped?: boolean;
}

const ProceedToApplicationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  isGrouped = false,
}: ProceedToApplicationModalProps) => {
  const subject = isGrouped ? 'these quotes' : 'this quote';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Proceed to Application</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Alert status="warning" borderRadius="md">
              <AlertIcon />
              <Text fontSize="sm">
                By proceeding to application the form will be locked and{' '}
                {subject} will no longer be editable.
              </Text>
            </Alert>

            <Text fontSize="sm">What happens next:</Text>
            <List spacing={2} fontSize="sm">
              <ListItem>
                <ListIcon as={LockIcon} color="gray.500" />
                {isGrouped
                  ? 'An application is created for every quote in this group.'
                  : 'An application is created from the selected market.'}
              </ListItem>
              <ListItem>
                <ListIcon as={LockIcon} color="gray.500" />
                The quote form becomes read-only — you can still view it, but
                not change it.
              </ListItem>
              <ListItem>
                <ListIcon as={LockIcon} color="gray.500" />
                Any further changes are made on the policy form.
              </ListItem>
            </List>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={onConfirm} isLoading={isLoading}>
            Proceed &amp; Lock
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ProceedToApplicationModal;
